import React from 'react';
import cx from 'classnames';
import { makeStyles } from 'design-system';
import { GroupInstructionJson } from '@scale/shared/projectInstruction/types';
import { useProjectInstructionContext } from '../projectInstructionContext';
import Details from '../components/details';

const Group = ({ contentData, index }: { contentData: GroupInstructionJson; index: number }) => {
  const classes = useStyles();
  const { components, title } = contentData;
  const { isMobileView } = useProjectInstructionContext();
  return (
    <div className={cx(classes.container, { [classes.mobileView]: isMobileView })}>
      <h3 className={classes.title}>{title}</h3>
      {components.map((c: any, i: number) => (
        <div key={c.nodeId} className={classes.groupSectionItemContainer}>
          <Details contentData={c.content} index={[index, i]} />
        </div>
      ))}
    </div>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    '& iframe': {
      width: '100%',
      height: '100vh',
    },
  },
  mobileView: {
    padding: '10px 20px',
  },
  content: {
    '& p': {
      lineHeight: 1.6,
    },
    '&  strong': {
      fontWeight: 700,
    },
  },
  title: {
    fontWeight: 600,
  },
  groupSectionItemContainer: {
    marginBottom: '8px',
  },
}));

export default Group;
